//Copyright Open Trade Technology Ltd. 2023. All rights reserved.

import React from 'react'
import { useOtSelector } from '@react/redux/store'

export function useModalForm(props: { poolEventToCloseOn: string }) {
  const [closePoolEvent, setClosePoolEvent] = React.useState<string>(props.poolEventToCloseOn)
  const lastPoolEvent = useOtSelector((state) => state.poolState.lastEvent)

  React.useEffect(() => {
    if (closePoolEvent !== '' && lastPoolEvent === closePoolEvent) {
      const event = new Event('modalClose')
      window.dispatchEvent(event)
    }
  }, [closePoolEvent, lastPoolEvent])

  return { setClosePoolEvent }
}

export const closeForm = () => {
  const event = new Event('modalClose')
  window.dispatchEvent(event)
}
